<!--
  SPOSTAMENTO INTERNO — pagina a sé (rotta /journey/:date).

  Resta per i link esistenti e per chi arriva da un giorno del calendario. Il
  form vero sta in `JourneyFormComponent`, lo stesso che «Nuova prenotazione»
  apre sotto la scelta del servizio: una sola implementazione, due ingressi.

  «Percorso» era il nome interno: a schermo il servizio si chiama SPOSTAMENTO
  INTERNO, ed è così che lo nominano il menu e il selettore dei servizi. Vedi
  le trappole di naming.
-->
<template>
  <div class="jt-page">
    <header class="jt-pagehead">
      <button
        type="button"
        class="jt-back"
        aria-label="Torna indietro"
        @click="indietro"
      >
        ‹
      </button>
      <div>
        <h1 class="jt-title">
          Nuovo spostamento interno
        </h1>
        <p class="jt-sub">
          Sposta un'auto fra due tue sedi. Driver e jolly li assegna Simba dopo
          la conferma.
        </p>
      </div>
    </header>

    <JourneyFormComponent
      :data-iniziale="dataIniziale"
      @salvato="vaiInAgenda"
    />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import JourneyFormComponent from '../Components/JourneyFormComponent.vue';

export default {
  name: 'JourneyPage',
  components: { JourneyFormComponent },

  setup() {
    const router = useRouter();
    const route = useRoute();

    // `null` nel percorso è il valore che la rotta usa per «nessuna data»:
    // non è una svista, è il contratto di `rottaCreazione('journey')`.
    const dataIniziale = computed(() => {
      const d = String(route.params.date || '');
      return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : '';
    });

    // Agenda sul giorno dello spostamento appena creato.
    const vaiInAgenda = (giorno) => {
      router.push({ path: '/agenda', query: { giorno } });
    };

    const indietro = () => router.back();

    return { dataIniziale, vaiInAgenda, indietro };
  },
};
</script>

<!--
  ⚠️ `scoped`: queste classi (`.jt-page`, `.jt-title`) le usa solo questa
  pagina, ma finivano nel foglio globale. È lo stesso motivo per cui i tre form
  di prenotazione si scavalcavano fra loro.
-->
<style scoped>
/* Layout di pagina (le Corse usano journey-timeline.css via editor).

   ⚠️ Qui c'era `min-height: 100vh; margin: -20px; background: #f4f5f7`: la
   pagina usciva dal contenitore per dipingersi il fondo da sola. Il margine
   negativo era tarato su 20px, ma `.main-content` di padding ne ha 24: restava
   una cornice chiara di 4px su tre lati, e il grigio (#f4f5f7) non era nemmeno
   quello dell'app (#FAFAFA). Ora la pagina sta nel contenitore come Agenda e
   Nuova prenotazione, e il fondo lo mette l'app una volta sola. */
.jt-page {
  padding: 4px 8px 48px;
  text-align: left;
}

/* ---- Intestazione, come nelle altre pagine del restyling ---- */
.jt-pagehead {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 20px;
}
.jt-back {
  width: 30px;
  height: 30px;
  flex: none;
  border: 1px solid var(--color-border);
  background: #fff;
  border-radius: 6px;
  font-size: 15px;
  color: var(--color-text-secondary);
  cursor: pointer;
}
.jt-title {
  margin: 0;
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--color-text-primary);
}
.jt-sub {
  margin: 3px 0 0;
  font-size: 13px;
  color: var(--color-text-secondary);
}
</style>
